import React from 'react';
import ReactDOM from 'react-dom/client';
import { DotBotsAuth } from '@dotbots-boutique/auth-sdk';
import { DotBotsAuthProvider } from '@dotbots-boutique/auth-sdk/react';

import App from './App';
import Portal from './pages/Portal';
import PublicLeaderboard from './pages/PublicLeaderboard';
import './styles.css';

// Public pages (participant portal + public leaderboard) are served without
// the DotBots auth provider — visitors reach them via referral or share links
// without a marketplace session. The manager dashboard (everything else) is
// rendered inside the provider so the auth SDK can manage tokens.
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const path = window.location.pathname;

if (path.startsWith('/portal')) {
  root.render(
    <React.StrictMode>
      <Portal />
    </React.StrictMode>,
  );
} else if (path.startsWith('/leaderboard/')) {
  root.render(
    <React.StrictMode>
      <PublicLeaderboard />
    </React.StrictMode>,
  );
} else {
  const auth = new DotBotsAuth({
    appId: import.meta.env.VITE_DOTBOTS_APP_ID,
    apiUrl: import.meta.env.VITE_PLATFORM_API_URL,
  });

  root.render(
    <React.StrictMode>
      <DotBotsAuthProvider auth={auth}>
        <App />
      </DotBotsAuthProvider>
    </React.StrictMode>,
  );
}
